import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    total: 0,
  },
  reducers: {
    addItem: (state, action) => {
      const producto = action.payload;

      // Verificamos si el producto tiene talla
      if (producto.talla) {
        // Si tiene talla, buscamos el producto con idProducto y talla
        const itemIndex = state.items.findIndex(item => 
          item.idProducto === producto.idProducto && item.talla === producto.talla
        );
        if (itemIndex !== -1) {
          // Si el producto ya existe con esa talla, aumentamos su cantidad
          state.items[itemIndex].unidades += producto.unidades;
        } else {
          // Si no existe, lo agregamos como un nuevo producto
          state.items.push(producto);
        }
      } else {
        // Si no tiene talla, buscamos por idProducto
        const itemIndex = state.items.findIndex(item => item.idProducto === producto.idProducto);
        if (itemIndex !== -1) {
          // Si el producto ya existe, aumentamos su cantidad
          state.items[itemIndex].unidades += producto.unidades;
        } else {
          // Si no existe, lo agregamos al carrito
          state.items.push(producto);
        }
      }
      
      // Actualizamos el total después de agregar el producto
      state.total = state.items.reduce((acc, item) => acc + item.unidades, 0);
    },
    updateItem: (state, action) => {
      const { idProducto, talla, unidades } = action.payload;
      const itemIndex = state.items.findIndex(item =>
        item.idProducto === idProducto && (item.talla === talla || !talla)
      );

      if (itemIndex !== -1) {
        state.items[itemIndex].unidades = unidades;
      }
      
      // Actualizamos el total
      state.total = state.items.reduce((acc, item) => acc + item.unidades, 0);
    },
    removeItem: (state, action) => {
        const { idProducto, talla } = action.payload;
        // Eliminamos el producto por idProducto y talla (si la talla existe)
        if (talla) {
          state.items = state.items.filter(item => item.idProducto !== idProducto || item.talla !== talla);
        } else {
          state.items = state.items.filter(item => item.idProducto !== idProducto);
        }
        // Recalculamos el total después de eliminar
        state.total = state.items.reduce((acc, item) => acc + item.unidades, 0);
      },
    clearCart: (state) => {
      state.items = [];
      state.total = 0;  // Reseteamos el total a 0 cuando limpiamos el carrito
    },
    setCart: (state, action) => {
      state.items = action.payload || [];
      state.total = state.items.reduce((acc, item) => acc + (Number(item.unidades) || 0), 0);
    },
  },
});

export const { addItem, updateItem, removeItem, clearCart, setCart } = cartSlice.actions;

export default cartSlice.reducer;
